<template>
  <div class="details" id="apply">
    <header>
      <div class="search">
        <router-link :to="{ name: 'Live' }"
          ><img src="../../assets/images/logo.jpg" alt=""
        /></router-link>
      </div>
    </header>
    <div class="details_wrap" ref="details_wrap" v-if="videoData">
      <div class="video_ichat">
        <i-player
          style="width: 860px; height: 483px; overflow: hidden"
          :videoinfo="videoData"
          @funisCharge="funisCharge"
          :isCharge="isCharge"
          :isCanPlay="isCanPlay"
          v-on:endValue="end"
          v-on:ok="ok"
        >
        </i-player>
        <!--</div>-->
        <div class="menus">
          <div class="videotitle" v-if="this.$route.query.type == 'video'">
            <div class="title">
              <div class="name">
                {{ videoData.vTitle ? videoData.vTitle : "" }}
              </div>
              <p v-if="videoData.vCreateDt">
                {{ getTimes(videoData.vCreateDt) }}
              </p>
            </div>
            <div class="img_text" v-if="this.$route.query.type == 'video'">
              <img
                src="../../assets/images/sc.png"
                alt=""
                v-if="videoData.vIsCollect == 1"
                @click="userCollect(1)"
              />
              <img
                src="../../assets/images/unsc.png"
                v-if="videoData.vIsCollect == 0"
                @click="userCollect(0)"
                alt=""
              />
              <span>{{ texts }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="right_chat">
        <ul v-if="this.$route.query.type == 'video'" class="uls">
          <li @click="tolink(0)" :class="index == 0 ? 'active' : ''">
            课程介绍
          </li>
          <!-- <li @click="tolink(1)" :class="index == 1 ? 'active' : ''">PPT</li> -->
        </ul>

        <div class="content_live">
          <div v-if="index == 0" class="content_lecturer">
            <div
              style="height: 485px"
              v-if="
                videoData.vDesc != undefined &&
                videoData.vDesc != null &&
                videoData.vDesc != ''
              "
              v-html="videoData.vDesc"
            ></div>
            <i-lecturer :value="videoData.teacher" v-else></i-lecturer>
          </div>

          <div v-show="index == 1" class="photo">
            <div v-if="!isCharge">
              <photo
                v-if="pptlist && pptlist.length > 0"
                :imgs="pptlist"
              ></photo>
              <img
                src="../../assets/images/nothing.png"
                alt
                v-else
                class="nothing"
              />
            </div>
            <div v-else class="limits">
              <img src="../../assets/images/chahua.png" alt />
              <div class="a">
                <span>您尚未购买课程，购买课程后才能观看</span>
              </div>
            </div>

            <div class="buyCC" v-if="isCharge" @click="subscribe()">
              <span>购买课程</span>
              <span v-if="curPrice">¥{{ curPrice }}元</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="details_wrap" id="videomore">
      <div v-if="this.$route.query.type == 'video'">
        <!--相关视频推荐-->
        <div class="relvideo">
          <div class="container_wrap">
            <p class="videolesson">相关课程</p>

            <ul class="ul_wrap">
              <li
                class="container_item"
                v-for="(item, index) in video_newest"
                :style="{
                  'margin-right':
                    (index + 1) % 5 == 0 && index != 0 ? '0px' : '28px',
                }"
                :key="item.vId"
                @click="toDetails(item)"
              >
                <div class="num_type">
                  <p>
                    <span>{{ item.group.egName }}频道</span>
                  </p>
                  <p>
                    <span>{{ item.vViewCount }}人观看</span>
                  </p>
                </div>
                <div class="item_con">
                  <img
                    class="con_images"
                    :src="item.vPicUrl"
                    alt=""
                    v-if="item.vPicUrl"
                  />
                  <img
                    class="con_images"
                    :src="
                      item.vViewUrl +
                      '?x-oss-process=video/snapshot,t_5000,f_jpg,w_800,h_600,m_fast'
                    "
                    alt=""
                    v-else
                  />
                </div>
                <div class="text_desc">
                  <p class="item_title">{{ item.vTitle }}</p>
                  <div class="item_text">
                    <p>{{ item.vSpeaker || "&nbsp;" }}</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="none" v-if="video_newest.length == 0">
            <img src="../../assets/images/nonelist.png" alt="" />
            <p>敬请期待</p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showimg" class="showimg" @click="cancelshowimg">
      <img :src="imgurl" alt="" />
    </div>
    <div v-if="sharecontent" class="sharecontent" @click="sharecontent = false">
      <img src="../../assets/images/share.png" alt="" />
    </div>

    <!--支付二维码弹框-->
    <!--      v-show="payqrcode"
-->

    <el-dialog
      title="支付提示"
      :close-on-click-modal="false"
      :visible.sync="payqrcode"
      width="30%"
      :before-close="handleClose"
    >
      <div style="text-align: center" v-if="payqrcode">
        <p>支付金额：{{ this.curPrice }}元</p>
        <p>购买此课程，需微信扫码支付。</p>
        <p>购买后有效期半年可看</p>
        <span id="con_qrcode" ref="qrcode"></span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import iLecturer from "../container/lecturer";
import iCourse from "../container/course";
import iChat from "../iChat/iChat_old";
import iPlayer from "../container/player";
import MD5 from "@/assets/js/md5";

import weui from "weui.js";
import bus from "../bus/index";
import photo from "./photo";

import $ from "jquery";
import QRCode from "qrcodejs2"; //二维码
import loginService from '../../plugin/extendFn/loginService';
import AppSetting from '../../AppSetting';

export default {
  data() {
    return {
      payqrcode: false,
      winner: false, //显示获奖名单
      winnerlist: [], //获奖名单列表
      iswinner: "", //自己是否获奖
      lOrderFl: "", //是否显示获奖名单
      liv147: false, //147单独显示的
      order: 1,
      explain: true,
      passwordvalue: "",
      errormsg: false,
      isshow: false,
      pptlist: [],
      sharecontent: false,
      reginfo: false,
      active: this.$route.query.type == "live" ? 0 : 0,
      // pptList:{},
      videoData: null,
      index: 0,
      sing: 0,
      text: "预约报名",
      texts: "收藏",
      anlist: [],
      boxheight: "",
      teacher: this.$route.query.type == "live" ? "1" : "0",
      list: [],
      video_newest: null,
      // lessonInfo:null,
      ra_wxUser: null,
      isQuestion: false,
      issuccessinfo: false,
      answer: [],
      rightanswer: [],
      socket: "",
      name: "",
      org: "",
      hasNameOrg: "",
      imgurl: "",
      showimg: false,
      homeicon: true,
      ismember: false,
      num: "0",
      position: {
        bottom: 50,
        right: 27,
      },
      clientX: "",
      clientY: "",
      topHeight: "",
      fl: "",
      onpresscTime: 0, //  阻止短时间内连续点击
      manager: null,
      questfl: null,
      sign: "",
      timestamp: "",
      videoToken: "",
      mediaChannelKey: "",
      liveSdk: null,
      timer: null,
      isBuyed: "", //用户是否购买
      curPrice: "",
      payfl: 0,
      isVipBuy: 0, //默认不是会员购买
      isCanPlay: null,// 是否在可播放的时间段内
    };
  },
  props: ["ClassTimePlayer", "videoUrl"],
  components: {
    iLecturer,
    iCourse,
    iChat,
    iPlayer,

    photo,
  },
  created() {
    this.$waiting.show(3);
  },
  methods: {
    funisCharge(type) {
      if (type == 1) {
        //需要支付
        this.subscribe();
      }
    },
    handleClose() {
      document.getElementById("con_qrcode").innerHTML = "";
      this.payqrcode = false;
      this.payfl = 0;
      window.clearInterval(this.timer);
    },
    //购买课程
    async subscribe() {
      if (this.payfl == 1) {
        this.$message.warning("请勿重复点击！");
        return false;
      }
      if(await loginService.isNotLogin())
      {
        this.login()
      }
      else {
        let ra_wxUser =await loginService.getLoginUser();

        if (ra_wxUser.uPhone && ra_wxUser.uOrg) {
          this.payfl = 1;

          if (this.curPrice == 0) {
            //0元不需要显示二维码 直接生成订单
            this.payqrcode = false;
          } else {
            this.payqrcode = true;
          }
          let param = {
            type: 1,
            orderType: this.$route.query.type == "video" ? 1 : "", //vip购买，1 视频购买，2直播购买，3专栏购买
            bId:
              this.$route.query.type == "video"
                ? this.$route.query.videoId
                : "",
            payPrice: this.curPrice,
            uid: ra_wxUser.uId,
            isVipBuy: this.isVipBuy,
          };
          this.$postHttp(AppSetting.baseUrl + "/order/app/add", param).then((res) => {
            if (res.data.code == 0) {
              console.log("+++++++++++++++++++++++++++++++++++++++++");
              if (this.curPrice == 0) {
                this.$message.success("支付成功！");
                location.reload();
                return false;
              }
              const pay_params = JSON.parse(res.data.parMap);
              const orderid = res.data.id; //订单号 用于查询支付状态
              console.log("支付信息", pay_params);
              let qrcode = new QRCode(this.$refs.qrcode, {
                text: pay_params.code_url,
                width: 200,
                height: 200,
                colorDark: "#333333", //二维码颜色
                colorLight: "#ffffff", //二维码背景色
                correctLevel: QRCode.CorrectLevel.H, //容错率，L/M/H
              });

              this.timer = setInterval(() => {
                this.$postHttp(AppSetting.baseUrl + "/order/app/search", {
                  id: orderid,
                }).then((result) => {
                  // console.log(result)
                  if (result.data.code == 0) {
                    //data.orderStatus 0未支付，1支付成功，2支付失败
                    if (result.data.data.orderStatus == 1) {
                      this.$message.success("支付成功！");
                      document.getElementById("con_qrcode").innerHTML = "";
                      window.clearInterval(this.timer);
                      location.reload();
                      this.payqrcode = false;
                    } else if (result.data.data.orderStatus == 2) {
                      this.$message.success("支付失败！");
                      window.clearInterval(this.timer);
                      document.getElementById("con_qrcode").innerHTML = "";
                      this.payqrcode = false;
                    }
                  } else if (result.data.code == 2004) {
                    this.$message.error("订单号为空");
                  } else {
                    this.$message.error("查询失败");
                  }
                });
              }, 2000);
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      }
    },

    tolink(type) {
      if (type == 1 && this.isCharge) {
        //ppt  判断是否需要付费
        this.subscribe();
      } else {
        this.index = type;
      }
    },

    question(val) {
      console.log("接口是否已答题状态");
      this.questfl = val;
    },

    toDetails(item) {
      this.$router.push({
        name: "vDetails",
        query: { type: "video", videoId: item.vId },
      });
      window.location.reload();
    },

    onlineuser(data) {
      this.num = data;
    },
    startquestion(val) {
      this.isQuestion = val;
    },

    cancelshowimg() {
      this.showimg = false;
      this.issuccessinfo = false;
    },
    updateuser() {
      if (this.name == "" || this.org == "") {
        this.$message.error("请输入姓名和单位！");
        return false;
      }
      let params = {
        id: this.ra_wxUser.uId,
        name: this.name,
        org: this.org,
      };
      this.$postHttp(AppSetting.baseUrl + "/student/update", params).then((res) => {
        if (res.data.code == 0) {
          this.reginfo = false;
          this.hasNameOrg = 1;
          this.$postHttp(AppSetting.baseUrl + "/common/credential", {
            sid: this.ra_wxUser.uId,
            vid: this.$route.query.videoId,
          }).then((res) => {
            if (res.data.code == 0) {
              this.issuccessinfo = false;
              this.reginfo = false;
              this.showimg = true;
              this.$set(this.videoData, "vIsCredential", 1);
              this.imgurl = res.data.credential.creImgUrl;
            }
          });
        }
      });
    },
    isregisteringo() {
      if (this.hasNameOrg == 0) {
        //未输入信息
        this.issuccessinfo = false;
        this.reginfo = true;
      } else {
        //调用证书接口
        this.$postHttp(AppSetting.baseUrl + "/common/credential", {
          sid: this.ra_wxUser.uId,
          vid: this.$route.query.videoId,
        }).then((res) => {
          if (res.data.code == 0) {
            this.reginfo = false;
            this.showimg = true;
            this.$set(this.videoData, "vIsCredential", 1);
            this.issuccessinfo = false;
            this.imgurl = res.data.credential.creImgUrl;
          }
        });
      }
    },
    ok(val) {
      if (val == "success") {
        if (this.anlist.length < 1) {
          //没有题目
          this.isQuestion = false;
        } else {
          if (this.$route.query.type == "video") {
            //有题目 是否答题  是否领取证书
            if (this.videoData.vIsComplete == 0) {
              //未答题
              // bus.$emit('isstop','stop')
              this.isQuestion = true;
            } else if (this.videoData.vIsComplete == 1) {
              //已答题
              this.isQuestion = false;
            }
          } else {
            //直播  直播也有问卷调查差
            //有题目 是否答题  是否领取证书
            if (this.videoData.vIsComplete == 0) {
              //未答题
              // bus.$emit('isstop','stop')
              this.isQuestion = true;
            } else if (this.videoData.vIsComplete == 1) {
              //已答题
              this.isQuestion = false;
              // if(this.videoData.vIsCredential==0){//未领取证书
              //   // bus.$emit('isstop','stop')
              //   this.issuccessinfo = true;
              // }else{
              //
              // }
            }
          }
        }
      }
    },

    async userCollect(type) {
      if (await loginService.isNotLogin()) {
        this.login()
      } else  {
        this.ra_wxUser = await loginService.getLoginUser();
        if (type == 0) {
          this.$postHttp(AppSetting.baseUrl + "/video/collection", {
            uid: this.ra_wxUser.uId,
            vid: this.$route.query.videoId,
          }).then((res) => {
            bus.$emit("isstop", "stop");
            if (res.data.code == 0) {
              this.texts = "已收藏";
              this.videoData.vIsCollect = 1;

              this.$message({
                message: "收藏成功！",
                type: "success",
              });
            } else {
              this.$message.error("收藏失败！");
            }
          });
        } else {
          bus.$emit("isstop", "stop");
          weui.dialog({
            content: "确定要取消收藏吗？",
            className: "yors",
            buttons: [
              {
                label: "取消",
                type: "default",
                onClick: (res) => {},
              },
              {
                label: "确定",
                type: "primary",
                onClick: () => {
                  this.$postHttp(AppSetting.baseUrl + "/video/collection/cancel", {
                    uid: this.ra_wxUser.uId,
                    vid: this.$route.query.videoId,
                  }).then((res) => {
                    if (res.data.code == 0) {
                      this.texts = "收藏";
                      this.videoData.vIsCollect = 0;

                      this.$message({
                        message: "取消收藏成功",
                        type: "success",
                      });
                    } else {
                      this.$message.error("取消收藏失败！");
                    }
                  });
                },
              },
            ],
          });
        }
      }
    },
    login() {
      loginService.login(this.$router).then((loginUser) => {
        this.ra_wxUser = loginUser;
      });
    },
    end(val) {
      // this.list[2].name = val;
      // this.ppt = val;
    },
    async signUp(status) {
      if (await loginService.isNotLogin()) {
        this.login();
      } else{
        this.ra_wxUser =await loginService.getLoginUser();

        if (status == 0) {
          this.$postHttp(AppSetting.baseUrl + "/live/appointment", {
            uid: this.ra_wxUser.uId,
            lid: this.$route.query.liveId,
          }).then((res) => {
            if (res.data.code == 0) {
              this.$set(this.videoData, "lAppointNum", res.data.num);
              this.text = "已预约";
              this.sing = 1;
              this.$message.success("预约成功");
            } else {
              this.$message.error("预约失败");
            }
          });
        } else {
          weui.dialog({
            content: "确定要取消预约吗？",
            className: "yors",
            buttons: [
              {
                label: "取消",
                type: "default",
                onClick: (res) => {
                  // alert('取消')
                },
              },
              {
                label: "确定",
                type: "primary",
                onClick: () => {
                  this.$postHttp(AppSetting.baseUrl + "/live/appointment/cancel", {
                    uid: this.ra_wxUser.uId,
                    lid: this.$route.query.liveId,
                  }).then((res) => {
                    if (res.data.code == 0) {
                      this.$set(this.videoData, "lAppointNum", res.data.num);
                      this.text = "预约报名";
                      this.sing = 0;
                      this.$message.success("取消成功");
                    } else {
                      this.$message.error("取消预约失败");
                    }
                  });
                },
              },
            ],
          });
        }
      } 
    },
    getTimes(value) {
      let val = new Date(value).getTime();
      return new Date(val).Format("yyyy.MM.dd hh:mm");
    },
   
    getvideodetails() {
      this.$postHttp(AppSetting.baseUrl + "/video/detail", {
        vid: this.$route.query.videoId,
        uid: this.ra_wxUser ? this.ra_wxUser.uId : "0",
      }).then((res) => {
        if (res.data.code == 0) {
          // console.log(res);
          this.hasNameOrg = res.data.hasNameOrg;
          this.videoData = res.data.video;
          this.videoData.vIsComplete = this.videoData.vIsComplete; //是否进行过答题
          this.videoData.showWatermark = res.data.showWatermark; // 是否展示水印功能
          // this.fl = this.videoData.vFl;

          this.video_newest = res.data.video_related;
          //将此视频的价钱赋值
          this.curPrice = res.data.video.vFees;

          // this.vIsCharge = res.data.video.vIsCharge
          this.isBuyed = res.data.video.buyed;
          this.hasNameOrg = res.data.hasNameOrg;
          this.isCanPlay = res.data.isCanPlay;

          //放在够买过的之后
          //如果后台接口返回的为1代表此人这个视频可以免费播放
          //将curPrice为0 直接添加订单，不调用支付
          if (res.data.isfree == "1") {
            this.isVipBuy = res.data.isfree;
            this.curPrice = "0";
          } else if (res.data.video.vIsCharge == "0") {
            //免费
            this.curPrice = "0";
          }
          this.$waiting.hide();
          this.texts = this.videoData.vIsCollect == 1 ? "已收藏" : "收藏";
          // this.getTab();//
          // this.videoData.vIsShare = 1;

          //判断课程介绍是否有数据没有的话显示讲师介绍内容 有数据就不显示讲师内容

          if (this.videoData.vIsShare == 0) {
            //未分享
            let setval = setInterval(() => {
              // console.log(localStorage.getItem('share'))
              // console.log(this.$route.videoId)
              if (localStorage.getItem("share") == this.$route.query.videoId) {
                this.sharecontent = false;
                clearInterval(setval);
              }
            }, 500);
          }
        }
      });

      this.$postHttp(AppSetting.baseUrl + "/video/ppt", {
        vid: this.$route.query.videoId,
      }).then((res) => {
        if (res.data.code == 0) {
          this.pptlist = res.data.list;
        }
      });
    },
  },
  computed: {
    isCharge() {
      let status = false;
      if (!this.videoData || !this.videoData.buyed) {
        status = true;
      }

      return status;
    },
  },
  async mounted() {
    let that = this;
    this.ra_wxUser = await loginService.getLoginUser();
    
    this.$route.query.type = this.$route.query.type
      ? this.$route.query.type
      : "live";
    this.$route.query.liveId = this.$route.query.liveId
      ? this.$route.query.liveId
      : "";
    localStorage.setItem(
      "source",
      this.$route.query.source
        ? this.$route.query.source
        : this.$route.query.soucre
        ? this.$route.query.soucre
        : ""
    ); //小桔灯的链接给错了 先换上去
    localStorage.setItem(
      "userLiveId",
      this.$route.query.liveId
        ? this.$route.query.liveId
        : this.$route.query.videoId
        ? this.$route.query.videoId
        : ""
    );
    localStorage.setItem("usertype", this.$route.query.type == "live" ? 1 : 2);
    localStorage.setItem("share", "");
    await this.getvideodetails();
  },

  beforeRouteLeave(to, from, next) {
    //后台说不需要调用了
    // let res = this.$postHttp('/live/online/update',{lid:this.$route.query.liveId,type:0})
    //  console.log(res)
    // next();

    if (sessionStorage.getItem("ilnmtime") <= 0) {
      next();
    } else {
      if (this.ra_wxUser) {
        if (this.ra_wxUser.uPhone) {
          if (this.$route.query.type == "video") {
            let params = {
              vid: this.$route.query.videoId,
              uid: this.ra_wxUser ? this.ra_wxUser.uId : 0,
              time: sessionStorage.getItem("ilnmtime") * 1,
            };
            this.$postHttp(AppSetting.baseUrl + "/video/info/exit", params).then(
              (res) => {
                // console.log(res);

                if (res.data.code == 0) {
                  next();
                }
              }
            );
          } else {
            next();
          }
        } else {
          next();
        }
      } else {
        next();
      }
    }
  },
};
</script>
<style scoped lang="scss">
.nothing {
  width: 50%;
  display: block;
  margin: 30px auto;
}

#con_qrcode {
  width: 200px;
  height: 200px;
  margin: 20px auto;
  display: inline-block;
}

.photo {
  position: relative;
}

.buyCC {
  width: 100%;
  background: #05a2ff;
  position: absolute;
  bottom: 0px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  line-height: 40px;
  height: 40px;
  cursor: pointer;
}

.limits {
  img {
    width: 264px;
    height: 110px;
    margin-top: 50px;
  }

  margin: auto;
  font-size: 16px;
  color: #666666;
  text-align: center;
  line-height: 40px;

  .goMen {
    color: #5bb8f8;
  }
}

.bg {
  width: 100%;
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  min-height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
}

.desc {
  text-align: center;
}

#player {
  width: 406px;
  height: 200px;
}

.content_live {
  width: 406px;
  height: 524px;
  overflow-y: scroll;
  padding: 11px 9px 15px 11px;
  box-sizing: border-box;

  > div {
    height: 100%;
  }
}

.content_lecturer {
  width: 386px;
  height: 493px;
  overflow-y: scroll;
}

.content_live::-webkit-scrollbar {
  display: none;
}

.start {
  cursor: pointer;
  font-size: 15px;
  color: #f18c20;
  float: right;
  margin-top: 10px;
  margin-right: 50px;
  /*margin-left: 30px;*/
}

.container_wrap {
  /*width: 860px;*/
  /*height: 256px;*/
  /*float: left;*/
  position: relative;
  overflow: hidden;

  .ul_wrap {
    /*height: 256px;*/
    /*position: absolute;*/
    /*left: 0;*/
    /*transition: 0.5s;*/
    /*white-space:nowrap;*/
    width: 100%;
    margin-bottom: 20px;
  }

  .videolesson {
    font-size: 18px;
    height: 20px;
    font-weight: bolder;
    margin-top: 18px;
    line-height: 20px;
    margin-bottom: 15px;
    border-left: 5px solid #f18c20;
    padding-left: 4px;
  }

  .videolesson:before {
    /*content: '|';*/
    /*font-weight: bold;*/
    /*display: inline-block;*/
    /*width: 6px;*/
    /*color: #F18C20;*/
    /*margin-right: 4px;*/
  }
}

.text_desc {
  padding: 9px;
  box-sizing: border-box;
}

.right_chat {
  width: 406px;
  /*height: 614px;*/
  background: #f7f7f7;
  float: left;
  margin-left: 13px;

  .uls {
    width: 406px;
    font-size: 16px;
    color: #333333;
    background: rgba(241, 140, 32, 0.2);
    height: 40px;
    line-height: 40px;

    // li:nth-of-type(1):after {
      // content: "|";
      // color: #ffffff;
      // position: absolute;
      // right: -2px;
    // }

    li {
      cursor: pointer;
      position: relative;
      width: 100%;
      float: left;
      text-align: center;
      box-sizing: border-box;
      font-size: 16px;
    }
  }
}

.quesul {
  .title {
    p {
      font-size: 16px;
    }
  }
}

.toleft {
  position: absolute;
  width: 70px;
  height: 300px;
  background: rgba(0, 0, 0, 0.3);
  font-size: 42px;
  text-align: center;
  top: -10px;
  line-height: 300px;
  color: #ffffff;
  display: none;
  z-index: 2;
}

.toright {
  position: absolute;
  right: 0;
  top: -10px;
  width: 70px;
  height: 300px;
  background: rgba(0, 0, 0, 0.3);
  color: #ffffff;
  font-size: 42px;
  text-align: center;
  line-height: 300px;
  display: none;
  z-index: 2;
}

.container_wrap:hover .toleft {
  display: block;
  cursor: pointer;
}

.container_wrap:hover .toright {
  display: block;
  cursor: pointer;
}

.container_item {
  /*float: left;*/
  margin-right: 16px;
  box-sizing: border-box;
  display: inline-block;
  background: #ffffff;
  width: 232px;
  height: 240px;
  margin-bottom: 16px;
  border: 1px solid #eeeeee;
  padding-top: 10px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;

  .item_con {
    /*height: 111px;*/
    width: 212px;
    text-align: center;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;

    > div {
      border-radius: 5px;
      width: 212px;
      height: 120px;
      position: absolute;
      z-index: 1;
      background: rgba(0, 0, 0, 0.3);
      margin-left: 10px;
    }

    .con_images {
      width: 212px;
      margin-left: 10px;
      border-radius: 5px;
      height: 120px;
      display: block;
    }
  }

  .item_title {
    font-size: 14px;
    height: 44px;
    display: -webkit-box;
    -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
    -webkit-line-clamp: 2; /*限制文本行数*/
    /*white-space: nowrap;      !*超出的空白区域不换行*!*/
    overflow: hidden; /*超出隐藏*/
    text-overflow: ellipsis; /*文本超出显示省略号*/
    color: #333333;
  }

  .item_text {
    font-size: 12px;
    color: #666666;

    p:nth-of-type(2) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .num_type {
    font-size: 12px;
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    box-sizing: border-box;

    img {
      margin-right: 5px;
      position: relative;
      top: 5px;
    }

    p:nth-of-type(1) {
      color: #666666;
      width: 110px;
      overflow: hidden; /*超出隐藏*/
      display: -webkit-box;
      -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
      -webkit-line-clamp: 1; /*限制文本行数*/
      /*white-space: nowrap;      !*超出的空白区域不换行*!*/
      text-overflow: ellipsis; /*文本超出显示省略号*/
    }

    .see {
      width: 15px;
      height: 15px;
    }

    .lesson {
      width: 15px;
      height: 15px;
    }

    p span {
      font-size: 12px;
      color: #666666;
    }

    .title_time {
      color: #999999;
    }
  }

  /*.num_type {*/
  /*font-size: 16px;*/
  /*line-height: 25px;*/
  /*height: 25px;*/
  /*p:nth-of-type(1) {*/
  /*float: left;*/
  /*line-height: 24px;*/
  /*}*/
  /*p:nth-of-type(2) {*/
  /*float: right;*/
  /*}*/
  /**/
  /*}*/
}

.container_item:nth-last-of-type(1) {
  margin-right: 0px;
}

.none {
  width: 100%;
  background: #ffffff;
  /*padding-top: 2.64rem;*/
  box-sizing: border-box;
  text-align: center;

  img {
    width: 1.96rem;
    height: 1.28rem;
    display: inline-block;
    margin: 1.09rem auto 0px;
    /*width: 100%;*/
  }

  p {
    font-size: 0.26rem;
    color: #999999;
    text-align: center;
  }
}

.anstitle {
  margin-top: 10px;
  font-size: 18px;
  position: relative;

  .desctip {
    font-size: 12px;
    position: absolute;
    left: 20px;
    top: 10px;
  }
}

.pswcontent {
  position: relative;

  input {
    height: 40px;
  }

  p {
    position: absolute;
    top: 60px;
    font-size: 24px;
    color: red;
  }
}

.relvideo {
  border-top: 1px solid #eeeeee;
  margin-top: 14px;
  width: 100%;

  .title {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding-left: 34px;
    box-sizing: border-box;
    font-size: 16px;
    background: #fef4ec;
    margin-bottom: 16px;
  }
}

.videomore {
  margin-top: 14px;
  border-top: 1px solid #eeeeee;
  padding-top: 18px;
}

.ppt {
  float: left;
  font-size: 18px;
  /*height: 600px;*/
  box-sizing: border-box;
  /*overflow-y: scroll;*/
  .text_ppt {
    width: 384px;
    margin-top: 74px;
    background: #ffeec6;
    color: #333333;
    font-size: 16px;
    padding-left: 35px;
    line-height: 40px;
    height: 40px;
  }

  .pptwrap {
    width: 384px;
    height: 1150px;
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
  }

  ::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
}

.footer {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-around;

  button {
    width: 105px;
    height: 39px;
    border-radius: 10px;
    border: none;
    font-size: 14px;
    font-weight: 500;
    outline: none;
    color: #ffffff;
    background: #ffb441;
  }
}

.psw {
  width: 100%;
  height: 50px;
  border-radius: 5px;
  border: 1px solid #999999;
  outline: none;
  margin-bottom: 30px;
  padding: 0 20px;
  box-sizing: border-box;
}

.tips_content {
  width: 350px;
  height: 225px;
  border-radius: 10px;
  padding: 37px 43px;
  box-sizing: border-box;
  background: #ffffff;
  margin: 150px auto;

  > p {
    color: #333333;
    font-size: 16px;
    margin-bottom: 5px;
  }

  > div {
    font-size: 30px;

    span {
      display: inline-block;
      color: #999999;
    }

    > div {
      display: flex;
      padding-left: 20px;
      box-sizing: border-box;
      margin: 0 auto;

      > div {
        margin-bottom: 48px;
        border: 1px solid #999999;
        border-radius: 50%;
        width: 40px;
        display: flex;
        height: 40px;
        align-items: center;
        justify-content: center;
        margin-right: 20px;

        > div {
          width: 24px;
          height: 24px;
          border-radius: 50%;
        }
      }
    }
  }
}

#apply {
  /*background: #F6F6F6;*/
  position: relative;
  width: 100%;

  > header {
    min-width: 1280px;
    width: 100%;
    height: 57px;
    background: #ffffff;
    border-bottom: 1px solid #a2a2a2;

    .search {
      width: 1280px;
      min-width: 1280px;
      margin: 0 auto;
      box-sizing: border-box;

      a {
        > img {
          width: 50px;
          display: block;
        }
      }
    }
  }

  .top,
  .top > a {
    width: 100%;
    height: 68px;
    display: inline-block;
    background: #ffffff;
    padding-left: 76px;
    line-height: 68px;

    img {
      width: 201px;
    }
  }

  .details_wrap {
    width: 1280px;
    min-width: 1280px;
    margin: 11px auto 0px;
    overflow: hidden;
    flex-grow: 0;
    z-index: 1;

    .video_ichat {
      width: 860px;
      float: left;
    }

    .line {
      height: 20px;
      background: #f6f6f6;
    }
  }
}

.active {
  color: #f18c20 !important;
  border-bottom: 1px solid #f18c20;
  box-sizing: border-box;
}

.box {
  background: #ffffff;
  flex-grow: 1;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  position: relative;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  display: flex;
}

.container {
  padding: 20px 30px;
  box-sizing: border-box;
  flex-grow: 1;
  /*width: 100vw;*/
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 0;
  overflow-y: scroll;
  /*会导致z-index失效*/

  -webkit-overflow-scrolling: touch;
}

.livetitle,
.live_title {
  height: 50px;

  .title {
    width: 720px;
  }

  > div {
    float: left;
  }
}

.videotitle {
  .title {
    width: 700px;
    float: left;
  }

  .img_text {
    float: left;
    font-size: 15px;
    cursor: pointer;
  }
}

.livetitle,
.videotitle {
  width: 100%;
  overflow: hidden;
  /*box-sizing: border-box;*/
  .title {
    /*padding-left: 20px;*/
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .live_line {
    color: #666666;
    font-size: 14px;
  }

  .live_num {
    color: #efbd87;
    font-size: 14px;
  }

  p {
    font-size: 14px;
    color: #666666;
  }

  .name {
    width: 650px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 18px;
    white-space: nowrap;
  }
}

.menus {
  height: 80px;
  width: 100%;
  background: #f7f7f7;
  padding: 15px;
  box-sizing: border-box;
}

.img_text {
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  img {
    width: 20px;
    margin-right: 9px;
  }

  color: #666666;
}

#messageinfo {
  z-index: 1002;
}

.messageinfo {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  z-index: 1002;

  button {
    border: none;
    outline: none;
    background: linear-gradient(#e7e8e9, #babbbb);
    width: 2rem;
    height: 0.6rem;
    color: #666666;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
  }
}

.showimg,
.sharecontent {
  position: absolute;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);

  img {
    width: 100%;
    margin-top: 2rem;
    z-index: 9999;
  }
}

.sharecontent > img {
  margin-top: 0;
}

#homeicon {
  position: absolute;
  bottom: 1.3rem;
  right: 0.3rem;
  width: 1rem;
  height: 1rem;
  /*z-index: 2;*/
}

.people {
  display: flex;
  padding-left: 10px;
  justify-content: space-between;
  align-items: center;
  height: 42px;

  span:nth-of-type(1) {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/container/vDetails.vue